import { saveAs } from "file-saver";
import Excel from "exceljs";
//---------------------------------------------------------------------
import { useMyStore } from "src/components/main/mainStore";
import {
    mimeTypeMap, 
    getDatefromWeekNum, 
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function Export({
    filteredForms, 
    week, 
}){
    const user = useMyStore(state => state.user);
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const handleExport = () => {
        setShowLoader(true);
        const data1 = filteredForms.filter(d => d.outside === "locator").map(f => ({...f, yard: f[week].form[0].yard, [week]: {...f[week], form: f[week].form.filter(f => f.inYard)}}));
        const data2 = filteredForms.filter(d => d.outside === "standby").map(f => ({...f, yard: f[week].form[0].yard, [week]: {...f[week], form: f[week].form.filter(f => f.inYard)}}));
        const data3 = filteredForms.filter(d => d.outside === "qew").map(f => ({...f, yard: f[week].form[0].yard, [week]: {...f[week], form: f[week].form.filter(f => f.inYard)}}));
        const mainData2 = [data1, data2, data3].filter(arr => arr.length).reduce((a, b) => [...a, {}, {}, ...b]);
        if(!data1.length && !data2.length && !data3.length){
            window.alert("Nobody submitted.");
            return;
        }
        if(mainData2.length === 4){
            window.alert("Nobody submitted.");
            return;
        }
        //--------------------------------
        const workbook = new Excel.Workbook();                            
        workbook.creator = user.userName;
        workbook.created = new Date();
        workbook.calcProperties.fullCalcOnLoad = true; 
        const worksheet = workbook.addWorksheet(week, {views: [{showGridLines: false}]});
        worksheet.state = "visible";
        worksheet.properties.defaultColWidth = 18;
        //--------------------------------
        const form = mainData2[0][week].form;
        for(let index0 = 1; index0 <= 2; index0++){
            for(let index1 = 1; index1 <= 6 + 2 * form.length; index1++){
            worksheet.getCell(index0, index1).alignment = { vertical: "middle", horizontal: "center" };
            worksheet.getCell(index0, index1).fill = {
                type: "pattern",
                pattern:"solid",
                fgColor:{argb:"4472C4"}
            };
            worksheet.getCell(index0, index1).border = {
                top: {style:"thin"},
                left: {style:"thin"},
                bottom: {style:"thin"},
                right: {style:"thin"}
            };
            worksheet.getCell(index0, index1).font = {
                color: { argb: "FFFFFF" },
                size: index0 === 2 && 
                (
                    index1 === 1 || 
                    index1 === 2 || 
                    index1 === 4 + 2 * form.length || 
                    index1 === 5 + 2 * form.length || 
                    index1 === 6 + 2 * form.length
                )?11:12,
                bold: true
            }
            }
        }
        worksheet.mergeCells(1, 3, 1, 2 + form.length);
        worksheet.getCell(1, 3).value = "Available to assist another yard";
        worksheet.mergeCells(1, 3 + form.length, 1, 2 + 2 * form.length);
        worksheet.getCell(1, 3 + form.length).value = "Working OT at assigned";
        worksheet.getCell("A2").value = "First Name";
        worksheet.getCell("B2").value = "Last Name";
        for(let formi = 0; formi < form.length; formi++){
            worksheet.getCell(2, 3 + formi).value = form[formi].weekDay;
            worksheet.getCell(2, 3 + form.length + formi).value = form[formi].weekDay;
        }
        worksheet.getCell(2, 3 + 2 * form.length).value = "Not Available";
        worksheet.getCell(2, 4 + 2 * form.length).value = "Assigned Yard";
        worksheet.getCell(2, 5 + 2 * form.length).value = "City of Residence";
        worksheet.getCell(2, 6 + 2 * form.length).value = "Cell Phone #";
        
        for(let totalI = 0; totalI < mainData2.length; totalI++){
            for(let totalII = 1; totalII <= 6 + 2 * form.length; totalII++){
                const cell = worksheet.getCell(totalI + 3, totalII);
                cell.alignment = { vertical: "middle", horizontal: "center" };
                cell.fill = {
                    type: "pattern",
                    pattern:"solid",
                    fgColor:{argb: (totalI + 3) % 2?"B4C6E7":"D9E1F2"}
                };
                cell.border = {
                    top: {style:"thin"},
                    left: {style:"thin"},
                    bottom: {style:"thin"},
                    right: {style:"thin"}
                };
            }
            worksheet.getCell(totalI + 3, 1).value = mainData2[totalI].firstName;
            worksheet.getCell(totalI + 3, 2).value = mainData2[totalI].lastName;
            for(let formi = 0; formi < form.length; formi++){
                if(JSON.stringify(mainData2[totalI]) !== "{}"){
                    worksheet.getCell(totalI + 3, 3 + formi).value = mainData2[totalI][week].form?.[formi] && mainData2[totalI][week].form[formi].inYard === "Yes"?"X":"";
                    worksheet.getCell(totalI + 3, 3 + form.length + formi).value = mainData2[totalI][week].form?.[formi] && mainData2[totalI][week].form[formi].outYard === "Yes"?"X":"";
                }else{
                    worksheet.getCell(totalI + 3, 3 + formi).value = "";
                    worksheet.getCell(totalI + 3, 3 + form.length + formi).value = "";
                }
            }
            if(JSON.stringify(mainData2[totalI]) !== "{}"){
                worksheet.getCell(totalI + 3, 3 + 2 * form.length).value = !mainData2[totalI][week].form?"":mainData2[totalI][week].form.some(f => !(f.inYard === "No" && f.outYard === "No"))?"": "X";
            }else{
                worksheet.getCell(totalI + 3, 3 + 2 * form.length).value = "";
            }
            worksheet.getCell(totalI + 3, 4 + 2 * form.length).value = mainData2[totalI].yard;
            worksheet.getCell(totalI + 3, 5 + 2 * form.length).value = mainData2[totalI].residence;
            worksheet.getCell(totalI + 3, 6 + 2 * form.length).value = mainData2[totalI].phoneNumber;
        }

        worksheet.columns.forEach(column => {
            const minLength = 18;
            let maxLength = 0;
            column["eachCell"]({ includeEmpty: true }, cell => {
                // exclude row 1 ----------
                if(cell.row === 1) return;
                //-------------------------
                const columnLength = cell.value?
                cell.value.toString().length * (cell.font?cell.font.size / 11 * 1.2:1)
                :minLength;
                if(columnLength > maxLength){
                    maxLength = columnLength;
                }
            });
            column.width = maxLength < minLength ? minLength : maxLength;
        });
        //--------------------------------------------------
        workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(new Blob([buffer], { type: mimeTypeMap.xlsx }), 
            `POT ${getDatefromWeekNum(week, 4).slice(5)} to ${getDatefromWeekNum(week, 10).slice(5)}.xlsx`);
            setShowLoader(false);
        })
        //--------------------------------------------------
    }
    //--------------------------------------------------------------------------------------------
    return(
        <span className = "pointer" onClick = {() => handleExport()}>Export</span>
    )
}